import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { SessionProvider } from './lib/session.js';
import { initI18n } from './i18n.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A host stand is often on hotel wifi. Retry, but do not hammer.
      retry: 1,
      staleTime: 10_000,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root missing from index.html');

// i18n resolves the locale and sets <html lang/dir> BEFORE the first render, so
// an Arabic-speaking host never sees a frame of left-to-right layout.
void initI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
});
